import * as React from "react";
function SvgIcChevronLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.716 5.375l-3.85 6.669 3.85 6.669-.649.375L10 12.044 14.067 5l.649.375z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronLeft;
